module.exports = {
  IN: 'in',
  LK: 'lk',
  BG: 'bd'
}